<template>
  <ul class="social-share social-style--2 color-black d-flex justify-content-start liststyle">
    <li v-for="(social, i) in socialList" :key="i">
      <a target="_blank" :href="social.url">
        <i :class="[social.prefix, social.icon]"></i>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      socialList: [
        {
          // prefix: "fab",
          // icon: "fa-google-scholar",
          prefix: "fas",
          icon: "fa-graduation-cap",
          url: "https://scholar.google.com/citations?user=YQ3tN_wAAAAJ&hl=en",
        },
        {
          prefix: "fab",
          icon: "fa-github",
          url: "https://github.com/doem97",
        },
        {
          prefix: "fab",
          icon: "fa-linkedin-in",
          url: "https://www.linkedin.com/",
        },
        {
          prefix: "fab",
          icon: "fa-researchgate",
          url: "https://www.researchgate.net/profile/Zichen-Tian-2",
        },
        {
          prefix: "fab",
          icon: "fa-instagram",
          url: "https://www.instagram.com/doem1997/",
        },
      ],
    };
  },
};
</script>
